export default __webpack_public_path__ + "static/media/control.a5a59df6.svg";